import React from "react";
import Reservation from "../../Component/Reservations";

export default function TourReservation({ reservationMode = "예약" }) {
  return <Reservation type="투어" reservationMode={reservationMode} />;
}
